// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__15H51","footer":"ModalUpdate_footer__pNEPq"};